export default __webpack_public_path__ + "static/media/synergyland.aaba5cc6.png";